module.exports = __webpack_public_path__ + "static/media/HorizontalUpperAdPreview.30341d67.svg";